module.exports = __webpack_public_path__ + "media/images/emblems/Waldstatt-Blazono-290aedeae5257bfa6d2ff121a4664835.png";